import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * ProtectedRoute - Wraps routes that require authentication
 * 
 * Guests can still make transactions, but certain features like
 * viewing full transaction history require login
 */
const ProtectedRoute = ({ children, allowGuest = false }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Show nothing while checking auth state
  if (isLoading) {
    return (
      <div className="protected-route-loading">
        <div className="loading-spinner" />
      </div>
    );
  }

  // If guests are allowed, render children regardless of auth state
  if (allowGuest) {
    return children;
  }

  // If not authenticated and guests not allowed, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
